import admin from "./js/_admin";
import "./setup/js/_toggleClass";
import "./setup/js/_scaleRoot.2";
import "./setup/js/_swiper";
import "./setup/js/_scrollwatch";
// import "lazysizes";
// import "@fancyapps/fancybox";
$(document).ready(function () {
  $("#wrapper").scalePlatform();
  //$(".loading").removeClass("active");
});
window.addEventListener("load", function () {
  var url = new URL(window.location.href);
  var param_admin = url.searchParams.get("admin");
  admin.init();
  admin.executeFunctions();
  // Thay data-src trong source video thành src
  // $("video source").each(function () {
  //   var dataSrc = $(this).attr("data-src");
  //   if (dataSrc) {
  //     $(this).attr("src", dataSrc);
  //     // Trigger video load
  //     $(this).parent("video")[0].load();
  //   }
  // });
  $("#wrapper").scalePlatform();
  $(window).on("resize", function () {
    $("#wrapper").scalePlatform();
  });
  commonLibs();

  $("[data-fancybox]").fancybox({
    caption: function (instance, item) {
      return $(this).find("figcaption").html();
    },
  });
});

var commonLibs = function () {
  $("#wrapper").scalePlatform();

  $(".onelink").each(function () {
    $(".onelink").universalLink();
  });

  $("#navBurger").each(function () {
    $("#navBurger").toggleClassname({
      toggle: [
        {
          el: $("#floattop"),
          className: "active",
        },
        {
          el: $("#floatnav"),
          className: "active",
        },
        {
          el: $("#navBurger"),
          className: "is-active",
        },
        {
          el: $("#navBurger"),
          className: "active",
        },
      ],
    });
  });

  

  $("#asideRightToggle").each(function () {
    $(this).toggleClassname({
      toggle: [
        {
          el: $(".floatright__main"),
          className: "active",
        },
        {
          el: $(".floatright .aside"),
          className: "active",
        },
      ],
    });
  });

  $(".scrollTop").each(function () {
    $(this).on("click", function () {
      $("html, body").animate({ scrollTop: 0 }, 400);
    });
  });
  $("a").each(function () {
    $(this).on("click", function () {
      if (
        $(this).attr("href") == "#" ||
        $(this).attr("href") == "javascript:;" ||
        $(this).attr("href") == "javascript:void(0)"
      ) {
        return false;
      }
    });
  });

  // if ($("[data-lightbox]").length > 0) {
  //     $("[data-lightbox]").each(function () {
  //         $(this).lightBox({
  //             objLightBox: $(this).attr('href'),
  //             type: $(this).data('lightbox-type')
  //         });
  //     });
  // }


};
